<template>
	<div
		class="hidden flex-1 basis-1/2 flex-col items-center bg-won-green-light p-8 md:flex"
	>
		<div class="flex flex-1 flex-col items-center justify-center gap-4">
			<WLogoDesktop class="block max-w-full" />
			<div
				v-if="partner?.logo_url"
				class="flex flex-col items-center gap-0.5"
			>
				<p class="text-sm text-won-blue">In partnership with</p>
				<img
					:src="partner.logo_url"
					:alt="partner.name"
					class="max-h-16 max-w-[180px] object-contain"
				/>
			</div>
		</div>
		<p class="text-center text-sm text-won-blue">
			Help us personalize your experience
		</p>
	</div>
</template>

<script setup>
import WLogoDesktop from '../icons/w-logo-desktop.vue';

defineProps({
	partner: {
		type: Object,
		default: null,
	},
});
</script>
